












































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'CreativeDateVenueBindSelector'

  resources:
    calendar_date_resource:
      resourceName: 'calendar_date'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreative.id/calendar_dates/:calendarDate.id/edit'
      fetch: false

    venues:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreative.id/venues'
      params:
        quick_list: true

  vue:
    props: ['calendarDate', 'audienceCreative', 'options']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
    }

    data: ->
      selectedDateVenues: []
      selectedVenues: []

    computed:
      supplierId: -> @options?.supplierId || @$store.member.supplier.id
      dateVenueIds: -> @calendarDate.venue_ids || []
      dateVenues: ->
        items = []
        for venue in (@venues || [])
          items.push venue if venue.id in @dateVenueIds
        items

      dateVenuesTableData: ->
        for venue in @dateVenues
          id: venue.id
          data: venue
          location: @$options.filters.formatLocation(venue)
          street: venue.street
          name: venue.venue_name

      venuesTableData: ->
        for venue in (@venues || [])
          continue if venue.id in @dateVenueIds
          id: venue.id
          data: venue
          location: @$options.filters.formatLocation(venue)
          street: venue.street
          name: venue.venue_name

      optionsForBindSelector: ->
        required: true
        title: 'Venues that host this date'
        description: 'Setup the locations that host this experience on this date'
        addButtonText: 'Add New Venue'
        addExistingButtonText: 'Add Existing Venue'
        why: 'You can schedule this at as many venues as you need, just add one venue at a time.'

    methods:
      hiDateVenuesSelectionChange: (venues) ->
        @selectedDateVenues = venues
      hiDateVenuesRowClick: (row) ->
        @$refs.dateVenuesTable.toggleRowSelection row
      hiUnbindDateVenue: (venue) ->
        @unbindVenuesFromDateTrigger [venue]
      hiUnbindSelectedDateVenues: ->
        @unbindVenuesFromDateTrigger @selectedDateVenues

      hiVenuesSelectionChange: (venues) ->
        @selectedVenues = venues
      hiVenuesRowClick: (row) ->
        @$refs.venuesTable.toggleRowSelection row
      hiBindVenue: (venue) ->
        @bindVenuesToDateTrigger [venue]
      hiBindSelectedVenues: ->
        @$refs.bindSelector.close()
        @bindVenuesToDateTrigger @selectedVenues

      bindVenuesToDateTrigger: (venues) ->
        @$emit 'bind'
        for chunk in @chunkArray(venues)
          payload = { venue_ids: chunk.map((v) => v.id) }
          @triggerResource 'calendar_date_resource', 'bind_venues', payload
      onCalendarDateResourceBindVenues: (_, item) ->
        @$refs.dateVenuesTable?.clearSelection()
        @$emit 'change', item

      unbindVenuesFromDateTrigger: (venues) ->
        @$emit 'bind'
        for chunk in @chunkArray(venues)
          payload = { venue_ids: chunk.map((v) => v.id) }
          @triggerResource 'calendar_date_resource', 'unbind_venues', payload
      onCalendarDateResourceUnbindVenues: (_, item) ->
        @$emit 'change', item

export default VueOptions.vue settings
